import { PomodoroTimer } from "../../features/pomodoro/components/PomodoroTimer";
import { TwentyTimer } from "../../features/twenty/components/TwentyTimer";
import { StopwatchTimer } from "../../features/stopwatch/components/StopwatchTimer";
import { Modal } from "./Modal";
import type { PomodoroState } from "../../features/pomodoro/hooks/use-pomodoro";
import type { TwentyState } from "../../features/twenty/hooks/use-twenty";

interface MobileTimerPanelProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly showPomodoro: boolean;
  readonly showTwenty: boolean;
  readonly showStopwatch: boolean;
  readonly pomodoro: {
    readonly state: PomodoroState;
    readonly start: () => void;
    readonly pause: () => void;
    readonly reset: () => void;
    readonly skip: () => void;
  };
  readonly twenty: {
    readonly state: TwentyState;
    readonly start: () => void;
    readonly pause: () => void;
    readonly reset: () => void;
    readonly skip: () => void;
  };
  readonly stopwatch: {
    readonly state: import("../../features/stopwatch/hooks/use-stopwatch").StopwatchState;
    readonly start: () => void;
    readonly pause: () => void;
    readonly reset: () => void;
    readonly lap: () => void;
    readonly formatTime: (ms: number) => string;
  };
  readonly onTimerSettings: () => void;
}

export function MobileTimerPanel({
  open,
  onClose,
  showPomodoro,
  showTwenty,
  showStopwatch,
  pomodoro,
  twenty,
  stopwatch,
  onTimerSettings,
}: MobileTimerPanelProps) {
  if (!open) return null;

  return (
    <Modal title="Timers" onClose={onClose} maxWidth="md">
      <div className="flex flex-col gap-3">
        {showPomodoro && (
          <PomodoroTimer
            state={pomodoro.state}
            onStart={pomodoro.start}
            onPause={pomodoro.pause}
            onReset={pomodoro.reset}
            onSkip={pomodoro.skip}
            onSettings={onTimerSettings}
          />
        )}
        {showTwenty && (
          <TwentyTimer
            state={twenty.state}
            onStart={twenty.start}
            onPause={twenty.pause}
            onReset={twenty.reset}
            onSkip={twenty.skip}
            onSettings={onTimerSettings}
          />
        )}
        {showStopwatch && (
          <StopwatchTimer
            state={stopwatch.state}
            onStart={stopwatch.start}
            onPause={stopwatch.pause}
            onReset={stopwatch.reset}
            onLap={stopwatch.lap}
            formatTime={stopwatch.formatTime}
            onSettings={onTimerSettings}
          />
        )}
      </div>
    </Modal>
  );
}
